// @ts-expect-error Untyped import
import ReportsTable from './ReportsTable';
import AsyncReportsListSubHeader from './AsyncReportsListSubHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ReportsTableContainer = props => {
  const {
    isBusinessUnitsLoading
  } = props;
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "my-reports-container",
    children: [/*#__PURE__*/_jsx(AsyncReportsListSubHeader, {}), /*#__PURE__*/_jsx(ReportsTable, {
      isBusinessUnitsLoading: isBusinessUnitsLoading
    })]
  });
};
export default ReportsTableContainer;